const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PROJECT_TIMES':
      return action.projectTimes;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/projectTimes.js